import { useMemo } from "react";

/**
 * @param {Object} params
 * @param {number} params.volumenBAP        // requerido
 * @param {number} params.duracionMeseta     // requerido (horas) > 0
 * @param {1|2}    params.cantidadEscalones  
 */
export default function useCalculoEscalones({
    volumenBAP = 0,
    duracionMeseta = 0,
    cantidadEscalones = 0,
}) {
    return useMemo(() => {
        // guardas de seguridad
        const dur = Math.max(1, Number(duracionMeseta) || 1);
        const bap = Math.max(0, Number(volumenBAP) || 0);
        const escalones = (cantidadEscalones === 1 ? 1 : 2);

        const factor = escalones === 2 ? 0.85 : 0.90;

        // Vol Meseta (ceil, sin decimales)
        const volMeseta = Math.ceil((bap * factor) / dur);

        // Primer/Segundo escalón (ceil)
        const volPrimerEscalon =
            escalones === 2 ? Math.ceil(volMeseta / 4) : Math.ceil(volMeseta / 2);

        const volSegundoEscalon =
            escalones === 2 ? Math.ceil(volMeseta / 2) : null;

        // Volumen total V
        const volumen =
            escalones === 2
                ? (volMeseta * dur) + (volPrimerEscalon * 4) + (volSegundoEscalon * 2)
                : (volMeseta * dur) + (volPrimerEscalon * 2);

        return {
            volMeseta,
            volPrimerEscalon,
            volSegundoEscalon, // null si es 1 escalón
            volumen,
        };
    }, [volumenBAP, duracionMeseta, cantidadEscalones]);
}
